import { History } from 'lucide-react';
import { usePermissions } from '@/features/auth';
import { Button, Card, EmptyState } from '@/shared/components';

interface Props {
  canStart: boolean;
  isStarting: boolean;
  onStart: () => void;
}

export function NoVersions({ canStart, isStarting, onStart }: Props) {
  const { hasPermission } = usePermissions();
  const showStart = canStart && hasPermission({ resource: 'document_template', action: 'edit' });

  return (
    <Card>
      <EmptyState
        icon={History}
        title="No versions yet"
        description="This template has never been published and has no draft. Each version you publish will appear here."
        actions={
          showStart && (
            <Button type="button" size="sm" onClick={onStart} disabled={isStarting}>
              {isStarting ? 'Starting...' : 'Start draft'}
            </Button>
          )
        }
      />
    </Card>
  );
}
